/**
 * Cost Management Router
 * Routes to cost monitoring and AWS management sections
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AIAWSMonitor from '../ai/AIAWSMonitor';

export const CostManagement: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="overview" replace />} />
      <Route path="overview" element={<AIAWSMonitor />} />
    </Routes>
  );
};

export default CostManagement;
